import { useFeature } from 'common/hooks/useFeature';
import { useCanAccessInvoicesPage } from 'modules/invoices/hooks/useCanAccessInvoicesPage';
import FEATURES from 'src/core/constants/features';

export const useShouldPromptUserToActivateInvoiceFeature = (): boolean => {
  const isInvoiceFeatureEnabled = useFeature(FEATURES.SUBMIT_MY_INVOICE);
  const hasAccessToInvoicesPage = useCanAccessInvoicesPage();

  return hasAccessToInvoicesPage && !isInvoiceFeatureEnabled;
};
